<template>
  <div class="content">
    <div class="set_flexwrap">
      <div class="flex_wrap">
        <el-form ref="form" :model="formdata" label-width="150px">
          <el-form-item label="商城首页是否显示购物车按钮">
            <el-radio-group v-model="formdata.cart_show">
              <el-radio-button
                v-for="(item,index) in commissionshowtype"
                :label="item.value"
                :key="index"
              >{{item.label}}</el-radio-button>
            </el-radio-group>
            <p>此设置仅对简洁版、精装版首页生效；产品手册不展示。</p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api.js";
import { commissionshowtype } from "@/util/util.js";
export default {
  name: "shoppingCartSetting",
  data() {
    return {
      commissionshowtype: commissionshowtype,
      formdata: {
        cart_show: ""
      }
    };
  },
  created() {
    this.queryconfigcart();
  },
  methods: {
    // 查询购物车设置
    queryconfigcart() {
      let params = {};
      this.axios
        .post(api.shopconf_cart, params)
        .then(response => {
          if (response.data.code == 0) {
            this.formdata.cart_show = response.data.info.cart_show;
          } else {
          }
        })
        .catch(() => {});
    },
    save() {
      this.submitsave();
    },
    // 保存
    submitsave() {
      let params = {
        cart_show: this.formdata.cart_show
      };
      this.axios
        .post(api.shopconf_conf_edit, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>